import { useCallback } from 'react';
import { Flex } from 'antd';
import { useAppSelector } from '@Hooks/index';
import useStatusFinderByNum from '@Hooks/useStatusFinderByNum';
import { getPurchaseClassifications } from '@Store/selectors/dictionarySelector';
import { PurchaseFormResponse } from '@Types/api/form';
import { MAvatar, Status } from '@Components/Base';
import { parseDateTime } from '@Utils/transformDateTime';

import { useGetUsersListByNameQuery } from '@Store/api/userApiSlice';
import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';

import styles from '../view-detailes-modal.module.css';

interface DetailItemProps {
  purchaseDetails: PurchaseFormResponse;
}

const DetailItem: React.FC<DetailItemProps> = ({ purchaseDetails }) => {
  const { findStatus } = useStatusFinderByNum('Purchase');
  const purchaseClassifications = useAppSelector(getPurchaseClassifications);
  const userName = purchaseDetails?.approver || null;

  const { data: users = [] } = useGetUsersListByNameQuery(userName);

  const prOfficerUser =
    purchaseDetails &&
    users.find(
      (item) => item.empNumber === String(purchaseDetails?.approverNo)
    );

  const { data: userPhoto } = useGetEmpPhotoQuery(
    prOfficerUser?.empImageName || ''
  );

  const findClassification = useCallback(
    (classificationId: number): string => {
      return (
        purchaseClassifications.find(
          (classification) => classification.codeNum === classificationId
        )?.codeDesc || ''
      );
    },
    [purchaseClassifications]
  );

  return (
    <>
      <div className={styles.viewItem}>
        <span>PR No.</span>
        <span className={styles.viewItemValue}>{purchaseDetails.reqNo}</span>
      </div>
      <div className={styles.viewItem}>
        <span>Status</span>
        <Status
          className={styles.viewItemValue}
          text={findStatus(Number(purchaseDetails.statusId))?.codeDesc || ''}
        />
      </div>
      <div className={styles.viewItem}>
        <span>Request From</span>
        <span className={styles.viewItemValue}>
          {purchaseDetails.reqFromId === -1 ? 'Buildsmart' : 'TBMS 2.0'}
        </span>
      </div>
      <div className={styles.viewItem}>
        <span>TBMS MR.No/ERP PR No.</span>
        <span className={styles.viewItemValue}>{purchaseDetails.mrNo}</span>
      </div>
      <div className={styles.viewItem}>
        <span>Material Group</span>
        <span className={styles.viewItemValue}>
          {purchaseDetails.group3Desc}
        </span>
      </div>
      <div className={styles.viewItem}>
        <span>Classification</span>
        <span className={styles.viewItemValue}>
          {findClassification(purchaseDetails.classificationId)}
        </span>
      </div>
      <div className={styles.viewItem}>
        <span>Request Date</span>
        <span className={styles.viewItemValue}>
          {parseDateTime(purchaseDetails.reqDate)}
        </span>
      </div>
      <div className={styles.viewItem}>
        <span>Required Date</span>
        <span className={styles.viewItemValue}>
          {parseDateTime(purchaseDetails.requiredOn)}
        </span>
      </div>
      <div className={styles.viewItem}>
        <span>Store/Project</span>
        <span className={styles.viewItemValue}>{purchaseDetails.project}</span>
      </div>
      <div className={styles.viewItem}>
        <span>Purchase Officer</span>
        <Flex align="center">
          <MAvatar size={24} src={userPhoto} />
          <span className={styles.viewItemValue}>
            {purchaseDetails.approver}
          </span>
        </Flex>
      </div>
    </>
  );
};

export default DetailItem;
